import type { ForManagerLocationDetail } from "@sidegigllc/api/client";
import { queries as directOfferHeaderQueries } from "domains/postGig/containers/DirectOfferHeader/queries";
import type { MarketplaceSearch } from "domains/schedule/utils/useMarketplaceSearch";
import type { WarmableQuery } from "routing/warmQueries";

type QueriesInput = { location: ForManagerLocationDetail; search: MarketplaceSearch };

// Only the first step (event name / dates) renders on load; later steps fetch on navigation.
export const queries = (input: QueriesInput): Array<WarmableQuery> => directOfferHeaderQueries(input);
